module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    staticClass: "date-field",
    attrs: {
      "slot": "activator",
      "label": _vm.label,
      "value": _vm.text,
      "required": _vm.required,
      "prepend-icon": _vm.icon,
      "rules": _vm.rulesMerged,
      "error-messages": _vm.errorMessages,
      "mask": "##.##.####",
      "readonly": _vm.readonly || _vm.calendarOnly,
      "hint": _vm.hint,
      "placeholder": _vm.placeholder,
      "tabindex": _vm.tabindex
    },
    on: {
      "input": _vm.updateText,
      "blur": _vm.onBlur
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "escape", undefined, $event.key, undefined)) { return null; }
        return _vm.resetText(_vm.value)
      }
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": _vm.locale,
      "no-title": "",
      "color": "primary",
      "first-day-of-week": "1",
      "allowed-dates": _vm.allowedDates,
      "max": _vm.max,
      "min": _vm.min
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var cancel = ref.cancel;

        return [_c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": _vm.selectToDay
          }
        }, [_vm._v("Сегодня")])]
      }
    }]),
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53627ea0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DateField.vue
// module id = 811
// module chunks = 1